<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">{{BusinessTitle}}</b></h3>
        </div>
      </div>
      <div class="card-body">
        <el-form :model="dynamicValidateForm" ref="ruleForm" class="demo-dynamic">
            <div>
              <table id="uniquetable" class="table rounded table-top" style="width: 100%;">
                    <thead class="thead-dark text-center">
                        <tr>
                          <th style="width: 25%;">費目カテゴリ</th>
                          <th style="width: 25%;">費目名</th>
                          <th style="width: 10%;">再委託フラグ</th>
                          <th style="width: 30%;">備考</th>
                          <th style="width: 10%;"></th>
                        </tr>
                    </thead>
                    <tbody >
                      <tr v-for="(data, index) in dynamicValidateForm.dataForm">
                          <td style="width: 25%;">
                              <el-form-item :prop="`dataForm.${index}.category_id`" label="">
                                  <el-select v-model="data.category_id" class="input-select" style="width: 100%" placeholder="オプション選択">
                                      <el-option v-for="item in listCate" :key="item.category_id" :label="item.name" :value="item.category_id">
                                      </el-option>
                                  </el-select>
                              </el-form-item>

                          </td>
                          <td style="width: 25%;">
                              <el-form-item class="mb-0" :key="data.key" :prop="`dataForm.${index}.himoku_name`">
                                  <el-input v-model="data.himoku_name" :maxlength="maxLengthHimokuName" :key="index">
                                  </el-input>
                              </el-form-item>
                          </td>
                          <td class="text-center" style="width: 10%;">
                            <el-form-item class="mb-0" :key="data.key">
                              <el-checkbox v-model="data.saiitaku_flg_befor_update" :key="index" :true-label="1" :false-label="0"></el-checkbox>
                            </el-form-item>
                          </td>
                          <td style="width: 30%;">
                            <el-form-item class="mb-0"  :key="data.key">
                              <el-input v-model="data.himoku_biko" :maxlength="maxLengthHimokuBiko" :key="index">
                              </el-input>
                            </el-form-item>
                          </td>
                          <td  class="text-center" style="width: 10%;">
                            <el-button class="delete-btn" type="danger" icon="el-icon-delete" circle @click="openPopup(data.himoku_id, index)"></el-button>
                          </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              <el-form-item>
                <div class="mt-8">
                  <el-button type="primary" @click="addLine">行追加</el-button>
                </div>
                <div class="text-center mb-12">
                    <el-button type="primary" @click="submitForm">確定</el-button>
                </div>
            </el-form-item>
            <input type="hidden" name="_csrf" v-model="dynamicValidateForm._csrf" />
        </el-form>
      </div>
    </div>
    <Popup :id="popupId" :content="popupMessage">
      <b-button
        class="btn-primary"
        @click="deleteCost()"
      >
        はい
      </b-button>
      <b-button
        class="btn-primary"
        @click="$bvModal.hide(popupId)"
      >
        いいえ
      </b-button>
    </Popup>
  </div>
</template>

<script>
import apiService from "@/core/services/api.service";
import { GET_LIST_COST, DELETE_COST } from "@/core/services/store/businessCost.module";
import { mapActions, mapGetters } from "vuex";
import Popup from '@/view/components/Popup'
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { SUCCESS_MESSAGE, DELETE_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
  components: {
    Popup
  },
  data() {
    return {
      loading: false,
      popupId: 'costPopup',
      popupMessage: DELETE_MESSAGE,
      selectedDeleteId: null,
      selectedDeleteIndex: null,
      dynamicValidateForm: {
        dataForm: [{
          category_id:"",
          himoku_id: "",
          himoku_name: "",
          saiitaku_flg_befor_update: 0,
          himoku_biko: ""
        }],
        _csrf:''
      },
      isSubmit: false,
      maxLengthHimokuName: 32,
      maxLengthHimokuBiko: 64,
      listCate:{}
    };
  },
  computed: {
    ...mapGetters(["getListCost", "getSuccessful", "BusinessTitle"]),
  },
  async created() {
    this.loading = true
    const active = false
    await this.listCost(active)
    await this.getListCate()
    if (this.BusinessTitle == null) {
      await this.setTitleBusiness()
    }
    this.dynamicValidateForm.dataForm = this.getListCost
    this.dynamicValidateForm._csrf = getCsrfRandom()
    this.loading = false
  },
  methods: {
    ...mapActions([GET_LIST_COST, SET_TITLE_BUSINESS]),
    async addLine() {
      await this.dynamicValidateForm.dataForm.push({
          category_id:"",
          himoku_id: "",
        himoku_name: "",
        saiitaku_flg_befor_update: 0,
        himoku_biko: ""
      });

      const table = document.getElementById('uniquetable')
      const lastRow = table.rows[table.rows.length - 1]
      lastRow.scrollIntoView({ block: "start", behavior: "smooth" })
    },
      async getListCate() {
          // this.turnOffErrorMessage('ruleForm')
          const response = await apiService.get(`category/list`)

          if (response.data.code == 200) {
              this.listCate = response.data.data.map(item => {
                  return {
                      category_id: item.category_id,
                      name: item.name
                  }
              })
          }
          if (response.data.code == 400) {
              this.notifyError(response.data.message)
          }
      },
    async submitForm() {
      this.isSubmit = true
      this.$refs["ruleForm"].clearValidate()
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const dataInsert = this.dynamicValidateForm.dataForm
          this.loading = true
          apiService.post(`business-manager/add-cost`, { dataForm: dataInsert }).then(async (data) => {
            if (data && data.data && data.data.success) {
              this.notifySuccess(SUCCESS_MESSAGE)
              await this.listCost(false)
            } else {
              if (data.data.code == 422) {
                this.showErrorMessage(data.data.data, 'ruleForm')
              } else if (data.data.code == 400) {
                this.notifyError(data.data.message)
              } else {
                this.notifyError('error server')
              }
            }
            this.dynamicValidateForm.dataForm = this.getListCost
            this.loading = false
          }).catch(e => {
            this.loading = false
            this.notifyError(e)
          })
        } else {
          return false;
        }
      });
      this.isSubmit = false
    },

    openPopup(id, index) {
      this.selectedDeleteId = id
      this.selectedDeleteIndex = index
      this.$bvModal.show(this.popupId)
    },
    async deleteCost() {
      this.$bvModal.hide(this.popupId)
      if (!this.selectedDeleteId) {
        this.dynamicValidateForm.dataForm.splice(this.selectedDeleteIndex, 1)
      } else {
        try {
          this.loading = true
          const response = await apiService.get(`business-manager/delete-cost/${this.selectedDeleteId}`)
          if (response.data.code == 200) {
            this.notifySuccess(SUCCESS_MESSAGE)
            await this.listCost(false)

          }
          if (response.data.code == 400) {
            this.notifyError("Selected Cost is not exist")
          }

          this.dynamicValidateForm.dataForm = this.getListCost
          this.loading = false
        } catch (e) {
          this.loading = false
          this.notifyError(e)
        }
      }
    }
  }
}
</script>

<style scoped>
.table-top,.table-top th,.table-top td {
  border: 1px solid #EBEDF3;
  border-collapse: collapse;
}

#uniquetable thead {
  display: block;
  width: 100%;
}

#uniquetable tbody {
  display: block;
  width: 100%;
  max-height: 350px;
  overflow-y: overlay;
  overflow-x: hidden;
}

#uniquetable tbody tr,
#uniquetable thead tr {
  width: 100%;
  display: table;
}

#uniquetable tbody tr td,
#uniquetable thead tr th {
  display: table-cell;
  min-height: 75px;
}
</style>
